import { ResultFile } from '@alilc/lowcode-types';
import { createResultFile } from '../../../../../../../utils/resultHelper';

export default function getFile(): [string[], ResultFile] {
    const file = createResultFile(
        'README',
        'md',
        `
# Use antd in create-react-app ✨

[Create React App](https://facebook.github.io/create-react-app/) + [Ant Design](https://ant.design).

## Step by Step Documentation

- 🇺🇸 English: https://ant.design/docs/react/use-with-create-react-app
- 🇨🇳 中文：https://ant.design/docs/react/use-with-create-react-app-cn

## Preview

\`\`\`bash
$ npm install
$ npm start

or:

\`\`\`bash
$ yarn
$ yarn start
\`\`\`

## See more

- [antd](http://github.com/ant-design/ant-design/)
- [create-react-app](https://github.com/facebookincubator/create-react-app)
- [craco](https://github.com/gsoft-inc/craco)
- [craco-less](https://github.com/DocSpring/craco-less)

---

This project was bootstrapped with [Create React App](https://github.com/facebook/create-react-app).

## Available Scripts

In the project directory, you can run:

### \`npm start\`



    `,
    );

    return [[], file];
}
